const React = require('react');
const { renderToStaticMarkup } = require('react-dom/server');
const BlogComparison = require('../components/BlogComparison');
const { TARGET_SLUG } = require('./blogSeo');
function enhanceBlogArticle(document, slug) {
  if (slug !== TARGET_SLUG) return;
  const existing = { search: document.querySelector('.search-comparison-graphic'), companies: document.querySelector('.company-comparison-graphic') };
  Object.values(existing).filter(Boolean).forEach(figure => {
    const grid = figure.querySelector('[class$="comparison-grid"]');
    grid?.classList.add('blog-comparison');
    if (figure === existing.companies) grid?.classList.add('blog-comparison-companies');
    figure.querySelectorAll('[class$="comparison-card"]').forEach(card => card.classList.add('blog-comparison-card'));
    figure.querySelectorAll('.search-comparison-vs').forEach(el => el.classList.add('blog-comparison-vs'));
  });
  // Only link attributes and additive visual elements change; saved CMS copy stays intact.
  document.querySelectorAll('a').forEach(link => {
    if (/^(Check My Business Free|Run Your Free AI Search Audit)$/i.test(link.textContent.trim())) {
      link.setAttribute('href', '/scan');
    }
  });
  const cta = document.createElement('div');
  cta.className = 'blog-early-cta';
  cta.innerHTML = '<a class="blog-cta-card-btn" href="/scan">Check My Business Free</a>';
  const firstParagraph = document.querySelector('p');
  if (firstParagraph) firstParagraph.after(cta); else document.body.prepend(cta);
  // Only the requested comparison table gets a scroll container. Its existing
  // table, row and cell styles remain untouched, as do all other article tables.
  document.querySelectorAll('table').forEach(table => {
    const labels = [...(table.querySelector('tr')?.cells || [])].map(cell => cell.textContent.trim());
    if (labels.length !== 2 || !/traditional search/i.test(labels[0]) || !/AI[- ](?:assisted )?search/i.test(labels[1])) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'blog-search-table-scroll';
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Traditional search versus AI search comparison');
    wrapper.tabIndex = 0;
    table.before(wrapper);
    wrapper.appendChild(table);
  });
  document.querySelectorAll('h2, h3').forEach(heading => {
    const text = heading.textContent.trim();
    const kind = /Traditional Search\s+vs\.?\s+AI Search/i.test(text) ? 'search' : /A Simple Example/i.test(text) ? 'companies' : null;
    if (kind && !existing[kind]) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = renderToStaticMarkup(React.createElement(BlogComparison, { kind }));
      heading.after(wrapper.firstElementChild);
      existing[kind] = true;
    }
  });
}

module.exports = { enhanceBlogArticle };
